angular.module('iqxCore')
    .controller('CandidateApproveWebReferencesCtrl', function($scope, FormSvc, base64Svc, ApiSvc, SweetAlert, QuestionnaireSvc, $timeout, ApplicationSvc) {
        FormSvc.setOptions($scope, { fetchAPI: {}, doNotPreventNav: true, autoEdit: true })
        $scope.refSelected = false
        var questionsScope = {}

        $scope.getWebRefTypes = function() {
            return $scope.fetch({
                fetchAPI: 'callresult/NetGetWebReferenceTypes',
                fetchTarget: 'webRefTypes',
                multiRow: true,
                autoEdit: true,
                doNotPreventNav: true
            }).then(function() {
                // remove the nulls ...
                $scope.webRefTypes = $scope.webRefTypes.filter(r => r.WebRefTypeName)
            })

        }

        $scope.refName = function(refID) {
            if (refID === 0 || !refID) { return 'Generic' }
            refID = refID || $scope.refSelected
            var name = ''
            try {
                name = $scope.webRefTypes.filter(r => r.WebRefTypeID === refID)[0].WebRefTypeName
            } catch (error) {
                name = 'Generic'
            }
            return name
        }

        $scope.referenceTypeChanged = function(scope) {
            $scope.refSelected = scope.theRecord.referenceType

            return QuestionnaireSvc.fetch(scope, { // Fetch linked questions (compliance docs functionality)
                    tagTarget: 'tags',
                    tagLocation: 'R' + scope.RegDets.DepartmentID,
                    postVar: 'qanswers',
                    questionGroup: scope.refSelected,
                    alwaysShowQGroup0: true
                })
                .then(function() {
                    if (scope.tags && scope.tags.length) {
                        QuestionnaireSvc.reset(scope, { tagTarget: 'tags' }) // Ensure in pristine state
                        $timeout(function() { // Must be done after fully loaded
                            QuestionnaireSvc.linkFormFields(scope, { tagTarget: 'tags' })
                            scope.$broadcast('isEditing', true)
                            ApplicationSvc.isEditing = true
                        }, 0, true, true)
                    }
                })
                .then(function() {
                    questionsScope = scope
                })
        }

        $scope.getWebReferences = function() {
            return $scope.fetch({
                fetchAPI: 'callresult/NetGetWebReferences',
                fetchTarget: 'webReferences',
                multiRow: true,
                fetchWithPersonID: true,
                autoEdit: true,
                doNotPreventNav: true,
                booleanFields: ['AskCandidateBeforeSend'],
            })
        }

        $scope.getRegistrationDetails = function() {
            return ApiSvc.fetch($scope, {
                fetchAPI: 'callresult/NetCandidateRegDetails',
                fetchWithPersonID: true,
                fetchTarget: 'RegDets',
                multiRow: false,
                booleanFields: ['DepartmentPerm', 'DepartmentTemp']
            })
        }

        $scope.addReference = function() {
            return FormSvc.modalForm($scope, 'addReferenceForm', {}, 'lg', { label: 'col-sm-3', data: 'col-sm-7' })
                .then(function(formData) {
                    $scope.qanswers = QuestionnaireSvc.answers(questionsScope, { tagTarget: 'tags' })
                    return $scope.exec('call/NetSetWebReference', {
                        pPersonID: $scope.RegDets.PersonID,
                        pDepartmentID: $scope.RegDets.DepartmentID,
                        pRefereeAddressName: formData.refereename,
                        pRefereeSalutation: formData.refereesalutation,
                        pRefereePosition: formData.refereeposition,
                        pCompanyName: formData.refereecompanyname,
                        pAddr1: formData.refereeaddress1,
                        pAddr2: formData.refereeaddress2,
                        pAddr3: formData.refereeaddress3,
                        pTown: formData.refereetown,
                        pCounty: formData.refereecounty,
                        pCountry: formData.refereecountry,
                        pPostCode: formData.refereepostcode,
                        pHomePhone: formData.refereehomephone,
                        pWorkPhone: formData.refereeworkphone,
                        pMobilePhone: formData.refereemobilephone,
                        pFax: formData.refereefax,
                        pEmail: formData.refereeemail,
                        pPosition: formData.jobtitle ? formData.jobtitle : '',
                        pURLRequestCode: base64Svc.encode(`${$scope.RegDets.PersonID}|${formData.refereeemail}|${moment().toISOString()}`),
                        pStartDate: formData.startdate,
                        pEndDate: formData.enddate,
                        pRefType: $scope.refSelected,
                        pAskCandidateBeforeSend: (formData.dontSendImmediately ? 1 : 0),
                        qanswers: $scope.qanswers
                    })
                })
                .then(function() {
                    $scope.refSelected = false
                    QuestionnaireSvc.reset(questionsScope, { tagTarget: 'tags' })
                })
                .then(function() {
                    FormSvc.alert('Reference Added', '', 'success')
                })
                .then($scope.getWebReferences)
                .catch(function(e) {
                    $scope.refSelected = false
                    QuestionnaireSvc.reset(questionsScope, { tagTarget: 'tags' })
                })
        }

        $scope.approveReference = function(ref) {
            SweetAlert.swal({
                    title: "Send Reference?",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#337ab7",
                    type: "info",
                    text: 'Are you sure you want to send this reference? You cannot undo this action.',
                    showCancelButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })
                .then(function(result) {
                    if (result.value) {
                        return $scope.exec('call/NetUpdateWebReference', {
                            pPersonID: $scope.RegDets.PersonID,
                            pReferenceRequestID: ref.ReferenceRequestID,
                            pAskCandidateBeforeSend: 0
                        })
                    }
                })
                .then(function() {
                    return FormSvc.alert("Success", "Reference has been approved", "success")
                })
                .then($scope.getWebReferences)
        }

        $scope.getRegistrationDetails()
            .then($scope.getWebRefTypes)
            .then($scope.getWebReferences)
    })